import React, { useState, useContext } from 'react';
import {
  FaLinkedin, FaInstagram, FaYoutube, FaTiktok, FaWhatsapp, FaSnapchat, FaFacebook,
  FaXTwitter
} from 'react-icons/fa6';
import { FaPhoneAlt, FaMapMarkerAlt, FaClock } from 'react-icons/fa';
import { FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { Link } from 'react-router-dom';



import { PiThreadsLogo } from 'react-icons/pi'; // for Threads

import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../GlobalContext";
import logoImg from '../assets/justoffplan-logo5.png';
import { useTranslation } from 'react-i18next';

const quickLinks = [
  { key: 'buy_apartments', href: '/properties/type/apartment' },
  { key: 'luxury_villas', href: '/properties/type/villa' },
  { key: 'offplan_townhouses', href: '/properties/type/townhouse' },
  { key: 'latest_ai_projects', href: '/latest' },
  { key: 'investment_penthouses', href: '/properties/type/penthouse' },
  { key: 'premium_offplan', href: '/properties/type/off-plan' },
  { key: 'full_floors_sale', href: '/properties/type/full-floor' },
  { key: 'duplex_apartments', href: '/properties/type/duplex' },
  { key: 'hotel_apartments', href: '/properties/type/hotel-apartment' },
  { key: 'commercial_properties', href: '/properties/type/office' },
  { key: 'retail_properties', href: '/properties/type/retail' },
  { key: 'uae_developers', href: '/uae-developers' },
];


const popularAreas = [
  { key: 'palm_jumeirah', href: '/community-detail/palm-jumeirah' },
  { key: 'dubai_hills', href: '/community-detail/dubai-hills' },
  { key: 'downtown_dubai', href: '/community-detail/downtown' },
  { key: 'jvc', href: '/community-detail/jvc' },
];


export default function Footer({ ctaData = null }) {
  const navigate = useNavigate();
  const { addLead } = useContext(GlobalContext);
  const [email, setEmail] = useState("");
  const { t, i18n } = useTranslation();

  const [showExplore, setShowExplore] = useState(false);
const [showPopular, setShowPopular] = useState(false);


  const handleSubscribe = (e) => {
    e.preventDefault();
    console.log("Email submitted:", email);
  };

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
  };

  return (
  <footer className="bg-gray-900 text-gray-400 text-sm">

<div className="bg-gradient-to-r from-teal-500 to-blue-600 text-white text-center py-10 px-6">
  <h2 className="text-3xl font-bold mb-3">
    {ctaData?.heading || t('banner_title')}
  </h2>
  <p className="text-lg mb-6">
    {ctaData?.subheading || t('banner_subtitle')}
  </p>
<Link to={ctaData?.buttonLink || "/contact"}>
  <button className="bg-white text-teal-600 font-semibold px-6 py-3 rounded-lg shadow-lg hover:bg-gray-100 transition">
    {ctaData?.buttonText || t('get_in_touch')}
  </button>
</Link>

</div>


     <div className="max-w-7xl mx-auto px-6 md:px-4 py-10 grid grid-cols-1 md:grid-cols-4 gap-10">

        {/* Brand Info */}
        <div>
          <img src={logoImg} alt="justoffplan.ai" width="240"
            height="48"
            loading="lazy"
  className="h-12 mb-4" />
      <p className="mb-4 text-base md:text-lg leading-relaxed">{t('brand_description')}</p>

<div className="space-y-3 text-sm my-4">
  <div className="flex items-center gap-3 text-gray-300">
    <FaPhoneAlt className="text-teal-400" />
    <span>+971 55 255 4245</span>
  </div>
  <div className="flex items-center gap-3 text-gray-300">
    <FaMapMarkerAlt className="text-teal-400" />
    <span>Dubai, UAE</span>
  </div>
  <div className="flex items-center gap-3 text-gray-300">
    <FaClock className="text-teal-400" />
    <span>{t('working_hours', 'Mon–Fri: 9AM–6PM GST')}</span>

  </div>
</div>

          <p className="text-white pt-4 text-xs italic">{t('powered_by')}</p>
          

        </div>

        {/* Quick Links */}
<div>
<button
  className="text-white mb-2 font-semibold w-full flex justify-between items-center"
  onClick={() => setShowExplore(!showExplore)}
>
  {t('explore_properties')}
  <span className="block md:hidden">
    {showExplore ? <FaChevronUp className="inline-block ml-2" /> : <FaChevronDown className="inline-block ml-2" />}
  </span>
</button>

  {(showExplore || window.innerWidth >= 768) && (
    <ul className="space-y-2">
      {quickLinks.map((link) => (
        <li key={link.key}>
          <a href={link.href} className="hover:text-white">{t(`quickLinks.${link.key}`)}</a>
        </li>
      ))}
    </ul>
  )}
</div>


        {/* Popular Areas */}
<div>
<button
  className="text-white mb-2 font-semibold w-full flex justify-between items-center"
  onClick={() => setShowPopular(!showPopular)}
>
  {t('popular_areas')}
  <span className="block md:hidden">
    {showPopular ? <FaChevronUp className="inline-block ml-2" /> : <FaChevronDown className="inline-block ml-2" />}
  </span>
</button>

  {(showPopular || window.innerWidth >= 768) && (
    <ul className="space-y-2">
{popularAreas.map((area) => (
  <li key={area.key}>
    <a href={area.href} className="hover:text-white">{t(`popularAreas.${area.key}`)}</a>
  </li>
))}

    </ul>
  )}

  {/* Resources */}
  <h3 className="text-white mt-6 mb-2 font-semibold">{t('resources')}</h3>
  <a href="/contact" className="block hover:text-white mb-2">{t('contact_us')}</a>
  <a href="/blog" className="block hover:text-white mb-2">{t('blog')}</a>
  <a href="/faq" className="block hover:text-white">{t('faq')}</a>

  {/* Legal */}
  <h3 className="text-white mt-6 mb-2 font-semibold">{t('legal')}</h3>
  <a href="/privacy-policy" className="block hover:text-white mb-2">{t('privacy_policy')}</a>
  <a href="/terms-of-use" className="block hover:text-white">{t('terms_of_use')}</a>
</div>


        {/* CTA + Newsletter */}
<div>
  {/* Let's Talk */}
  <h3 className="text-white mb-4 font-semibold">{t('lets_talk')}</h3>
  <p className="mb-4">
    {t('footer_cta')} <br />
    {t('chat_on_whatsapp')}
  </p>
<a
  href="https://wa.me/971552554245"
  target="_blank"
  rel="noopener noreferrer"
  className="inline-flex items-center justify-center gap-2 bg-green-500 hover:bg-green-600 text-white px-6 py-2 rounded-md font-semibold mb-6 shadow-md transition"
>
  <FaWhatsapp className="text-xl" />
  {t('chat_now')}
</a>

  {/* Divider */}
  <hr className="border-gray-700 my-4" />

  {/* Get Deals */}
  <h3 className="text-white mb-2 font-semibold">{t('exclusive_deals')}</h3>
  <p className="mb-4">{t('exclusive_cta')}</p>
  <form onSubmit={handleSubscribe} className="mb-6">
    <div className="flex items-center">
      <input
        type="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        className="w-full px-3 py-2 rounded-l bg-gray-800 border border-gray-700"
        placeholder={t('placeholder_email')}
        required
      />
      <button
        type="submit"
        className="bg-teal-500 px-4 py-2 rounded-r text-white font-semibold hover:bg-teal-600"
      >
        {t('subscribe_button')}
      </button>
    </div>
  </form>

  {/* Follow Us */}
  <h3 className="text-white mb-2 font-semibold">{t('follow_us')}</h3>
          <div className="flex space-x-4 mt-4">
            <a href="https://www.facebook.com/profile.php?id=61575864781603" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="hover:text-white"><FaFacebook className="cursor-pointer" /></a>
            <a href="https://www.snapchat.com/add/justoffplan?share_id=YGje3wO1Vlw&locale=en-US" target="_blank" rel="noopener noreferrer" aria-label="Snapchat" className="hover:text-white"><FaSnapchat className="cursor-pointer" /></a>
            <a href="https://linkedin.com/company/offplan-ai" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="hover:text-white"><FaLinkedin className="cursor-pointer" /></a>
            <a href="https://www.instagram.com/justoffplan" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="hover:text-white"><FaInstagram className="cursor-pointer" /></a>
            <a href="https://www.tiktok.com/@justoffplan" target="_blank" rel="noopener noreferrer" aria-label="TikTok" className="hover:text-white"><FaTiktok className="cursor-pointer" /></a>
            <a href="https://www.youtube.com/@Justoffplan" target="_blank" rel="noopener noreferrer" aria-label="YouTube" className="hover:text-white"><FaYoutube className="cursor-pointer" /></a>
            <a href="https://wa.me/971552554245" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp" className="hover:text-white"><FaWhatsapp className="cursor-pointer" /></a>
             {/* New: Threads */}
  <a href="https://www.threads.net/@justoffplan" target="_blank" rel="noopener noreferrer" aria-label="Threads" className="hover:text-white"><PiThreadsLogo className="cursor-pointer" /></a>

  {/* New: X (formerly Twitter) */}
  <a href="https://x.com/Justoffplan" target="_blank" rel="noopener noreferrer" aria-label="X" className="hover:text-white"><FaXTwitter className="cursor-pointer" /></a>

          </div>

          {/* <div className="mt-6 text-sm text-white">
  <span className="mr-2">{t('language')}:</span>
  <button
    onClick={() => changeLanguage('en')}
    className={`underline hover:text-teal-400 ${i18n.language === 'en' ? 'text-teal-400' : ''}`}
  >
    {t('english')}
  </button>
  <span className="mx-2 text-gray-400">|</span>
  <button
    onClick={() => changeLanguage('ar')}
    className={`underline hover:text-teal-400 ${i18n.language === 'ar' ? 'text-teal-400' : ''}`}
  >
    العربية
  </button>
</div> */}

</div>
      </div>

      <div className="text-center text-gray-500 text-xs py-4 border-t border-gray-800">
        © 2025–{new Date().getFullYear()} justoffplan.ai. {t('rights_reserved')}
      </div>

      {/* Hidden SEO Links */}
      <div style={{ display: 'none' }}>
        <a href="/properties/type/jumeirah-village-circle" rel="nofollow">Jumeirah Village Circle Properties</a>
        <a href="/properties/type/downtown-dubai" rel="nofollow">Downtown Dubai Apartments</a>
        <a href="/properties/type/palm-jumeirah" rel="nofollow">Palm Jumeirah Villas</a>
        <a href="/dxboffplan" rel="nofollow">DXBoffplan</a>
        <a href="/uae-developers">UAE developer directory</a>
      </div>
    </footer>
  );
}
